import RatingBadge from './RatingBadge';

export default RatingBadge;
